import { useNavigate } from "react-router-dom";
import ModalContainer from "../UIElements/modal-container";
import { Box, Button, Stack, Typography } from "@mui/material";
import { CloseDrawerIcon } from "../UIElements/svg-icons";

export const VerifiedModal = ({
  open,
  modal_handler,
  onSubmit,
}: {
  open: boolean;
  modal_handler: () => void;
  onSubmit: () => void;
}) => {
  const navigate = useNavigate();

  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"xs"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={modal_handler}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <img
              src={"/assets/icons/onboarding/caution-icon.png"}
              style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
            /> */}
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Verification takes 24-48hrs
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            We'll notify you when you  are verified
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 600,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Welcome to ManagedMedics
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmit}
            sx={{
              mt: 2,
              borderRadius: "40px",
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};
